import { Transition } from "../../../core/flows/Transition";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";
import { QuickExchangeContext } from "../Context/QuickExchangeContext";

export class QuickExchangeTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<QuickExchangeContext>("quickExchangeContext", this.entryStep);

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }
        if (context.nextTo.length == 1 && context.nextTo.includes("RetrieveBooking")) {
            context.routeTo = []
        } else if (context.nextTo.length == 1 && context.nextTo.includes("CheckoutFlow")) {
            const ticketOptionContext = new TicketOptionContext()
            this.setCtx<TicketOptionContext>("ticketOptionContext", ticketOptionContext, this.entryStep);
            context.routeTo = ["CheckoutFlow"]
        }
        else {
            context.routeTo = ["QuickExchangeNextPrev_Step"]
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}